import { render } from "./KakaoManagement.vue?vue&type=template&id=280c2f0d&scoped=true"
import script from "./KakaoManagement.vue?vue&type=script&lang=js"
export * from "./KakaoManagement.vue?vue&type=script&lang=js"

import "./KakaoManagement.vue?vue&type=style&index=0&id=280c2f0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280c2f0d"]])

export default __exports__